var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28665 4.97998H7.76265V6.21332C8.11932 5.50398 9.03398 4.86665 10.408 4.86665C13.042 4.86665 13.6673 6.27865 13.6673 8.86932V13.6673H11.0007V9.45932C11.0007 7.98398 10.644 7.15198 9.73598 7.15198C8.47665 7.15198 7.95332 8.04865 7.95332 9.45865V13.6673H5.28665V4.97998ZM0.713984 13.554H3.38065V4.86665H0.713984V13.554ZM3.76265 2.03398C3.76275 2.2575 3.71842 2.47881 3.63224 2.68504C3.54606 2.89128 3.41975 3.07833 3.26065 3.23532C2.93825 3.55573 2.50186 3.73509 2.04732 3.73398C1.59358 3.73368 1.15819 3.55478 0.835318 3.23598C0.676792 3.07846 0.550908 2.8912 0.46488 2.68494C0.378852 2.47868 0.33437 2.25747 0.333984 2.03398C0.333984 1.58265 0.513984 1.15065 0.835984 0.831984C1.15857 0.512757 1.59414 0.333785 2.04798 0.333985C2.50265 0.333985 2.93865 0.513318 3.26065 0.831984C3.58198 1.15065 3.76265 1.58265 3.76265 2.03398Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.5ba5ee63766649789a8dae0e86e3c9a7.svg";
export { ForwardRef as ReactComponent };